

import templateServiceListPage from '@/app-template/lib/pages/ServiceListPage.vue';

export default {
  name: "ServiceListPage",
  components: { templateServiceListPage },
};
